module.exports = __webpack_public_path__ + "img/5.2125f76c.png";